import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { forkJoin, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { Country } from '@shared/models/country';
import { uniqueByLib } from '@shared/utils/unique.lib';
import { COUNTRY_FLAG_IMAGE_URL } from 'app.config';
import { ApiEndpoint } from '../enums/api-endpoints.enum';
import { ICallingCode } from '../interfaces/calling-code.interfaces';
import { ICountry } from '../interfaces/country.interfaces';

@Injectable({ providedIn: 'root' })
export class CountryService {
  private countries$: Observable<ICountry[]>;

  constructor(private http: HttpClient) {
    this.countries$ = forkJoin([
      this.http.get<Country[]>(ApiEndpoint.COUNTRIES),
      this.http.get<ICallingCode[]>(ApiEndpoint.COUNTRY_CALLING_CODES),
    ]).pipe(
      map(([countries, countryCodes]) => {
        const uniqueCountries = uniqueByLib(countries, (country) => country.name);
        const uniqueCountryCodes = uniqueByLib(countryCodes, (code) => code.country?.name);

        return uniqueCountries.map((country) => {
          const callingCode = uniqueCountryCodes.find((countryCode) => countryCode.country?.id === country.id);

          return {
            ...country,
            flag_icon: `${COUNTRY_FLAG_IMAGE_URL}${country.alpha3_code.toLowerCase()}.svg`,
            calling_code: callingCode?.code,
            calling_code_url: callingCode?.url,
          };
        });
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );
  }

  public getCountries(): Observable<ICountry[]> {
    return this.countries$;
  }
}
